import Money from "./Money";
import PresentmentPrice from "./PresentmentPrice";
import SelectedOption from "../SelectedOption";
import ShopifyProduct from "./ShopifyProduct";
import Image from "./Image";

export default class ShopifyVariant {
  id?: string;
  title?: string;
  sku?: string;
  unitPrice?: Money;
  availableForSale?: boolean;
  image?: Image;
  requiresShipping?: boolean;
  compareAtPriceV2?: Money;
  compareAtPrice?: string;
  price?: Money;
  presentmentPrices: PresentmentPrice[] = [];
  selectedOptions: SelectedOption[] = [];
  description: string = "";
  product?: ShopifyProduct;
  quantityAvailable: number = -1;

  constructor(response?: any) {
    if (response != null) {
      this.id = response.id;
      this.title = response.title;
      this.sku = response.sku;
      this.unitPrice = new Money(response.unitPrice);
      this.availableForSale = response.availableForSale;
      this.image = new Image(response.image);
      this.requiresShipping = response.requiresShipping;
      this.compareAtPriceV2 = new Money(response.compareAtPriceV2);
      this.quantityAvailable = response.quantityAvailable;
      this.price =
        response.presentmentPrices != null
          ? response.presentmentPrices.length > 0
            ? new Money(response.presentmentPrices.edges[0].node.price)
            : response.price
          : response.priceV2;

      if (response.presentmentPrices != null) {
        if (response.presentmentPrices.length > 0) {
          this.presentmentPrices = [];
          for (let key in response.presentmentPrices.edges) {
            this.presentmentPrices.push(
              new PresentmentPrice(response.presentmentPrices.edges[key].node)
            );
          }
        }
      }

      if (response.selectedOptions != null) {
        this.selectedOptions = [];
        for (let key in response.selectedOptions) {
          this.selectedOptions.push(
            new SelectedOption(response.selectedOptions[key])
          );
        }
      }
      this.product = new ShopifyProduct(response.product);
    }
  }
}
